// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollGroupDto } from './IPayrollGroupDto';
import {
    IPayrollGroupDtoFromJSON,
    IPayrollGroupDtoFromJSONTyped,
    IPayrollGroupDtoToJSON,
    IPayrollGroupDtoToJSONTyped,
} from './IPayrollGroupDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarResponseDto
 */
export interface IPayrollCalendarResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarResponseDto
     */
    frequency_type?: IPayrollCalendarResponseDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarResponseDto
     */
    group_type?: IPayrollCalendarResponseDtoGroupTypeEnum;
    /**
     * 
     * @type {Array<IPayrollGroupDto>}
     * @memberof IPayrollCalendarResponseDto
     */
    payroll_groups?: Array<IPayrollGroupDto>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarResponseDto
     */
    plan_ids?: Set<number>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarResponseDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarResponseDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarResponseDto interface.
 */
export function instanceOfIPayrollCalendarResponseDto(value: object): value is IPayrollCalendarResponseDto {
    return true;
}

export function IPayrollCalendarResponseDtoFromJSON(json: any): IPayrollCalendarResponseDto {
    return IPayrollCalendarResponseDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'payroll_groups': json['payroll_groups'] == null ? undefined : ((json['payroll_groups'] as Array<any>).map(IPayrollGroupDtoFromJSON)),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
    };
}

export function IPayrollCalendarResponseDtoToJSON(json: any): IPayrollCalendarResponseDto {
    return IPayrollCalendarResponseDtoToJSONTyped(json, false);
}

export function IPayrollCalendarResponseDtoToJSONTyped(value?: IPayrollCalendarResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'group_type': value['group_type'],
        'payroll_groups': value['payroll_groups'] == null ? undefined : ((value['payroll_groups'] as Array<any>).map(IPayrollGroupDtoToJSON)),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
    };
}

